import UserSearchResult from "../../components/UserSearch/UserSearch";

const UserSearch = () => (
    <div>
        <UserSearchResult />
    </div>
);

export default UserSearch;